<template>
  <v-dialog :value="dialog" max-width="600" persistent @input="closeModal">
    <v-card class="card">
      <v-card-title class="headline accent--text pb-4">
        {{ isEdit ? 'Редактировать' : 'Добавить' }}
      </v-card-title>
      <v-card-text outlined tile class="">
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-autocomplete
              v-model="blockTrigger.applicationType"
              :items="dictionaries.applicationType"
              item-text="name"
              label="Тип заявления"
              placeholder="Выберите из списка"
              outlined
              rounded
              dense
              return-object
              @input="$v.blockTrigger.applicationType.$touch()"
              @blur="$v.blockTrigger.applicationType.$touch()"
              :error-messages="errorMessages.applicationType"
            />
          </v-col>

<!--          <v-col cols="12" class="py-0">-->
<!--            <v-autocomplete-->
<!--              v-model="blockTrigger.speciality"-->
<!--              :items="dictionaries.speciality"-->
<!--              item-text="name"-->
<!--              label="Специальность"-->
<!--              placeholder="Выберите из списка"-->
<!--              outlined-->
<!--              rounded-->
<!--              dense-->
<!--              return-object-->
<!--              @input="$v.blockTrigger.speciality.$touch()"-->
<!--              @blur="$v.blockTrigger.speciality.$touch()"-->
<!--              :error-messages="errorMessages.speciality"-->
<!--            />-->
<!--          </v-col>-->

<!--          <v-col cols="12" class="py-0">-->
<!--            <v-autocomplete-->
<!--              v-model="blockTrigger.courseNumber"-->
<!--              :items="dictionaries.courseNumber"-->
<!--              item-text="name"-->
<!--              label="Курс"-->
<!--              placeholder="Выберите из списка"-->
<!--              outlined-->
<!--              rounded-->
<!--              dense-->
<!--              return-object-->
<!--              @input="$v.blockTrigger.courseNumber.$touch()"-->
<!--              @blur="$v.blockTrigger.courseNumber.$touch()"-->
<!--              :error-messages="errorMessages.courseNumber"-->
<!--            />-->
<!--          </v-col>-->

          <v-col cols="12" class="py-0">
            <v-autocomplete
              v-model="blockTrigger.submissionSession"
              :items="dictionaries.submissionSession"
              item-text="submissionName"
              label="Период подачи"
              placeholder="Выберите из списка"
              outlined
              rounded
              dense
              return-object
              @input="$v.blockTrigger.submissionSession.$touch()"
              @blur="$v.blockTrigger.submissionSession.$touch()"
              :error-messages="errorMessages.submissionSession"
            >
              <template #selection="{ item }">
                <span style="font-size: 14px">
                  {{ `${item.semester?.name} ${item.year?.name}`}}
                </span>
              </template>

              <template #item="{ item }">
                <span style="font-size: 14px">
                  {{ `${item.semester?.name} ${item.year?.name}`}}
                </span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" class="pt-0 pb-6">
            <DateField
              :date="blockTrigger.startDateTime"
              :max="blockTrigger.endDateTime"
              @updateDate="updateStartDateTime"
              label="Дата начала"
            />
          </v-col>

          <v-col cols="12" md="6" class="pt-0 pb-6">
            <TimeField
              :time="blockTrigger.startDateTime"
              :max="blockTrigger.endDateTime"
              @updateTime="updateStartDateTime"
              label="Время начала"
            />
          </v-col>

          <v-col cols="12" md="6" class="pt-0 pb-6">
            <DateField
              :date="blockTrigger.endDateTime"
              :min="blockTrigger.startDateTime"
              @updateDate="updateEndDateTime"
              label="Дата окончания"
            />
          </v-col>

          <v-col cols="12" md="6" class="pt-0">
            <TimeField
              :time="blockTrigger.endDateTime"
              :min="blockTrigger.startDateTime"
              @updateTime="updateEndDateTime"
              label="Время окончания"
            />
          </v-col>

        </v-row>
      </v-card-text>

      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn text color="lightGrey" @click="closeModal">Отмена</v-btn>
        <v-btn
          :loading="loading"
          :disabled="$v.$invalid"
          color="success"
          text
          @click="saveBlockTrigger"
        >
          {{ isEdit ? 'Сохранить' : 'Создать' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { BlockTrigger } from '@/models'
import DateField from '@/components/zvp/deadlinePage/DateField'
import TimeField from '@/components/zvp/deadlinePage/TimeField'
import { setValidateMessages } from '@/scripts/validation'
import { formatDateToISOString, formatDateToString } from "@/scripts"
import {mapGetters} from "vuex";

export default {
  props: {
    loading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

  components: {
    DateField,
    TimeField,
  },

  data: () => ({
    blockTrigger: new BlockTrigger(),
  }),

  validations() {
    return {
      blockTrigger: {
        applicationType: { required },
        courseNumber: {  },
        speciality: {  },
        submissionSession: { required },
        startDateTime: { required },
        endDateTime: { required }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),

    isEdit() {
      return this.selectedItem?.id
    },

    errorMessages() {
      const allErrors = {}
      Object.keys(this.$v.blockTrigger.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.blockTrigger[key])
      })
      return allErrors
    }
  },

  methods: {
    saveBlockTrigger() {
      this.$emit('saveBlockTrigger', this.blockTrigger)
    },

    updateStartDateTime(value) {
      this.blockTrigger.startDateTime = formatDateToISOString(formatDateToString(value)).slice(0, -3)
    },

    updateEndDateTime(value) {
      this.blockTrigger.endDateTime = formatDateToISOString(formatDateToString(value)).slice(0, -3)
    },

    resetModal() {
      this.$v.$reset()
      this.blockTrigger = new BlockTrigger()
    },

    closeModal() {
      this.blockTrigger = new BlockTrigger()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(value) {
      this.blockTrigger = value ? BlockTrigger.build(value) : new BlockTrigger()
    },

    dialog(val) {
      !val && this.resetModal()
    }
  }
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.card >>> .v-label.theme--light {
  font-size: 14px;
  color: rgba(55, 71, 79, .8) !important;
}

.card >>> .v-label.v-label--active.theme--light {
  font-size: 16px;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important
}
</style>
